export default __webpack_public_path__ + "img/Google hybrid.jpg";